import { isDefinedArray } from "et3-type-guards";
import getSupervisorReceiptStore from "../../stores/supervisor-store/supervisor-receipt-compensation-store";
import { issuePercentageCalculation } from "./receipt-compensation-calculation";
import { reduce } from "et3-type-guards";
import {
  MAXIMUM_NUMBERS_BEFORE_DOT,
  MAXIMUM_NUMBERS_AFTER_DOT,
  TWO_DOTS
} from "../../constants/input-entries-constants";
import { et3ReadableDecimalNumber } from "../et3-data-helper";
import { reducerToZeroIfUndefined } from "../et3-picker-data-helper";

export const checkInputValue = (value: string) => {
  const sringValue = reduce(() => `${value}`, "");
  const numberOfDots = sringValue.split(".").length;
  const stringBeforeDot = reduce(() => sringValue.split(".")[0], "");
  const stringAfterDot = reduce(() => sringValue.split(".")[1], "");
  const moreThanFourNumbersBeforeDot =
    stringBeforeDot.length > MAXIMUM_NUMBERS_BEFORE_DOT;
  const moreThanTwoNumbersAfterDot =
    stringAfterDot.length > MAXIMUM_NUMBERS_AFTER_DOT;
  const containOnlyDigitAndDots = /^\d*\.?\d*$/.test(value);
  const isPositiveOrZeroFloatNumber = parseFloat(value) >= 0;
  return {
    wrongInputValue:
      numberOfDots > TWO_DOTS ||
      moreThanFourNumbersBeforeDot ||
      moreThanTwoNumbersAfterDot ||
      !containOnlyDigitAndDots,
    correctInputValue:
      containOnlyDigitAndDots &&
      numberOfDots <= TWO_DOTS &&
      isPositiveOrZeroFloatNumber
  };
};

export const dataInputArray = () => {
  const dataInputObject = getSupervisorReceiptStore().dataInputObject.get();
  const dataInput = [
    {
      id: 0,
      ...dataInputObject,
      descriptionIssuesCount: {
        issuesCount: dataInputObject.descriptionIssuesCount,
        auditedEventType: "description"
      },
      pictureIssuesCount: {
        issuesCount: dataInputObject.pictureIssuesCount,
        auditedEventType: "picture"
      },
      reportIssuesCount: {
        issuesCount: dataInputObject.reportIssuesCount,
        auditedEventType: "report"
      },
      investigationCaseIssuesCount: {
        issuesCount: dataInputObject.investigationCaseIssuesCount,
        auditedEventType: "investigationCases"
      },
      issuesPercentageDescription: issuePercentageCalculation(
        dataInputObject,
        "description"
      ),
      issuesPercentagePicture: issuePercentageCalculation(
        dataInputObject,
        "picture"
      ),
      issuesPercentageReport: issuePercentageCalculation(
        dataInputObject,
        "report"
      ),
      issuesPercentageInvestigationCases: issuePercentageCalculation(
        dataInputObject,
        "investigationCases"
      )
    }
  ];
  return dataInput;
};

const getCurrentMonthCalculatedObject = () => {
  const supervisorCompensation =
    getSupervisorReceiptStore().currentMonthSupervisorReceipt.get();
  return {
    descriptionPricing: supervisorCompensation.description.price,
    descriptionDiscount: supervisorCompensation.description.discount,
    picturePricing: supervisorCompensation.picture.price,
    pictureDiscount: supervisorCompensation.picture.discount,
    reportPricing: supervisorCompensation.report.price,
    reportDiscount: supervisorCompensation.report.discount,
    investigationCasesPricing: supervisorCompensation.investigationCases.price,
    investigationCasesDiscount:
      supervisorCompensation.investigationCases.discount
  };
};

export const currentMonthSupervisorArray = () => {
  const id = isDefinedArray(
    getSupervisorReceiptStore().adminFinalReceipts.get()
  )
    ? getSupervisorReceiptStore().adminFinalReceipts.get().length + 1
    : 0;
  const finalSalary = getSupervisorReceiptStore().finalSalary.get();
  return [
    {
      id,
      finalSalary: et3ReadableDecimalNumber(finalSalary, 0),
      adminID: reducerToZeroIfUndefined(
        parseInt(getSupervisorReceiptStore().csrAdmins.get().value, 10)
      ),
      ...getCurrentMonthCalculatedObject()
    }
  ];
};
